/**
 * The login panel has to fit, install card and copyright included, on a
 * 768px-tall laptop screen. A second promo adds the indicator row, and Voice
 * AI's headline runs to two lines, so short screens get tighter spacing and
 * smaller artwork. Taller screens keep the original sizes.
 */
export const SHORT_SCREEN = "@media (max-height: 880px)";

/** Both artworks share one height so the slides line up. */
export const ARTWORK_HEIGHT = "var(--login-promo-artwork-height)";

export const artworkHeightSx = {
  "--login-promo-artwork-height": "min(38vh, 640px)",
  [SHORT_SCREEN]: { "--login-promo-artwork-height": "min(32vh, 640px)" },
  height: ARTWORK_HEIGHT
};
